var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.498,
    height: 97.228,
    viewBox: "0 0 85.498 97.228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2451",
    "data-name": "Group 2451",
    transform: "translate(-1504.336 -1546.942)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3697",
    "data-name": "Path 3697",
    d: "M3805.47,1569.371l-1.153-1-1.762-1.525-18.916-16.382-2.034-1.761-1.538-1.332a1.762,1.762,0,0,0-2.915,1.332v18.6a5.16,5.16,0,0,0,5.16,5.16h22a1.761,1.761,0,0,0,1.153-3.093Zm-24.794-2.523v-14.289l18.916,16.382h-16.823A2.093,2.093,0,0,1,3780.676,1566.848Z",
    transform: "translate(-2216.244)",
    fill: "#d9d8d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3698",
    "data-name": "Path 3698",
    d: "M1970.683,1555.969a5.5,5.5,0,0,1,5.5-5.5H2018.7l-2.034-1.761-1.538-1.332a1.76,1.76,0,0,0-1.153-.43h-38.433a8.381,8.381,0,0,0-8.381,8.381v11.133h3.523Z",
    transform: "translate(-451.304)",
    fill: "#d9d8d5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2444",
    "data-name": "Group 2444",
    transform: "translate(1504.336 1568.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3699",
    "data-name": "Path 3699",
    d: "M1922.5,2717.373a13.464,13.464,0,0,0-2.007-.094h-1.348v3.92h1.527a7.214,7.214,0,0,0,2.205-.217,1.834,1.834,0,0,0,.872-.679,1.858,1.858,0,0,0,.316-1.074,1.784,1.784,0,0,0-.443-1.244A1.932,1.932,0,0,0,1922.5,2717.373Z",
    transform: "translate(-1908.824 -2710.147)",
    fill: "#d9d8d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700",
    "data-name": "Path 3700",
    d: "M1504.336,2434.206v16.468a3.469,3.469,0,0,0,3.469,3.469h44.434a3.469,3.469,0,0,0,3.469-3.469v-16.468a3.469,3.469,0,0,0-3.469-3.469H1507.8A3.469,3.469,0,0,0,1504.336,2434.206Zm17.657,7.716a3.79,3.79,0,0,1-1.173,1.362,4.041,4.041,0,0,1-1.446.655,15.936,15.936,0,0,1-2.893.2h-1.819v5.211h-2.789v-13.815h4.476a16.279,16.279,0,0,1,3.317.207,3.622,3.622,0,0,1,1.988,1.353,4.288,4.288,0,0,1,.8,2.69A4.508,4.508,0,0,1,1521.993,2441.921Zm13.9,3.591a6.092,6.092,0,0,1-1.479,2.441,4.905,4.905,0,0,1-1.96,1.1,8.436,8.436,0,0,1-2.469.292h-5.249v-13.815h5.1a9.973,9.973,0,0,1,2.629.264,4.621,4.621,0,0,1,2.083,1.272,6.036,6.036,0,0,1,1.319,2.238,10.191,10.191,0,0,1,.452,3.265A9.08,9.08,0,0,1,1535.893,2445.512Zm12.279-7.643h-6.681v3.27h5.767v2.337h-5.767v5.871h-2.79v-13.815h9.471Z",
    transform: "translate(-1504.336 -2430.737)",
    fill: "#d9d8d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3701",
    "data-name": "Path 3701",
    d: "M2440.761,2718.061a2.656,2.656,0,0,0-1.291-.65,12.637,12.637,0,0,0-2.29-.132h-1.253v9.15h2.083a7.606,7.606,0,0,0,1.687-.132,2.577,2.577,0,0,0,1.126-.575,2.922,2.922,0,0,0,.73-1.333,9.025,9.025,0,0,0,.282-2.531,8.26,8.26,0,0,0-.282-2.459A3.162,3.162,0,0,0,2440.761,2718.061Z",
    transform: "translate(-2412.739 -2710.147)",
    fill: "#d9d8d5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1731",
    "data-name": "Rectangle 1731",
    width: 50.515,
    height: 3.523,
    rx: 1.761,
    transform: "translate(1527.588 1603.75)",
    fill: "#d9d8d5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1732",
    "data-name": "Rectangle 1732",
    width: 50.515,
    height: 3.523,
    rx: 1.761,
    transform: "translate(1527.588 1615.012)",
    fill: "#d9d8d5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1733",
    "data-name": "Rectangle 1733",
    width: 50.515,
    height: 3.523,
    rx: 1.761,
    transform: "translate(1527.588 1626.274)",
    fill: "#d9d8d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3702",
    "data-name": "Path 3702",
    d: "M2040.53,2349.123l-1.153-1-1.761-1.525v68.3a5.5,5.5,0,0,1-5.5,5.5h-55.924a5.5,5.5,0,0,1-5.5-5.5v-40.312h-3.523v40.958a8.381,8.381,0,0,0,8.381,8.381h57.215a8.381,8.381,0,0,0,8.381-8.381v-65.086A1.764,1.764,0,0,0,2040.53,2349.123Z",
    transform: "translate(-451.304 -779.753)",
    fill: "#d9d8d5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.80091b2b1cd6d76cfbc2549c08a766ca.svg";
export { ForwardRef as ReactComponent };